export const ATTRIBUTE_KEY_COMPONENT_FILTERS = 'component_filters';

export const SKIP_AMOUNT_UPDATE = -1;

export const NO_RAID_LEVEL_OPTION = 'no_raid_level';

export const WARRANTY_COMPONENT = 'warranty';

export const WARRANTY_ADDONS_COMPONENT = 'warranty_addons';

export const WARRANTY_YEARS_ATTRIBUTE = 'warranty_years';

export const WARRANTY_GROUP_ATTRIBUTE = 'warranty_group';
